import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { MENU_DATA_QUERY } from '../graphql/queries'
import { FETCH_MENU_DATA } from '../redux/action-types'

const useMenuDataLazyQuery = () => {
  const dispatch = useDispatch()

  const { isLoading, error, data } = useSelector(
    store => store.reports.menuData,
  )

  const fetch = useCallback(
    menuCurationTaskId =>
      apolloService.query({
        query: MENU_DATA_QUERY,
        variables: { menuCurationTaskId },
        dispatch,
        action: FETCH_MENU_DATA,
      }),
    [dispatch],
  )

  return [fetch, { isLoading, error, data }]
}

export default useMenuDataLazyQuery
